/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { EmptyWrap } from '@styles/base.style'
// import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { EMPTY_ICON } from '@constants/index'
import { GlobalStoreKey } from '@v2/constants/common'

interface AdvEmptyProps {
  ico?: EMPTY_ICON
}

export const AdvEmpty: React.FC<AdvEmptyProps> = observer((props: AdvEmptyProps) => {
  const { globalStore } = useRootStore()
  const { ico } = props
  let emptyIco = null
  let emptyTxt = null
  // let emptyElem = null
  const className = []

  const imageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value
  const basicEmpty = `${imageUrl}empty/basic_empty.png`
  const bettorEmpty = `${imageUrl}empty/bettor_empty.png`
  const chatPickEmpty = `${imageUrl}empty/chat_pick_empty.png`
  const clubNoteEmpty = `${imageUrl}empty/club_note_empty.png`
  const grayEmpty = `${imageUrl}empty/gray_empty.png`
  const leagueEmpty = `${imageUrl}empty/league_empty.png`
  const matchDetailEmpty = `${imageUrl}empty/match_detail_empty.png`
  const matchEmpty = `${imageUrl}empty/match_empty.png`
  const messageEmpty = `${imageUrl}empty/message_empty.png`
  const pickEmpty = `${imageUrl}empty/pick_empty.png`

  switch (ico) {
    case EMPTY_ICON.BETTOR:
      emptyIco = <img src={bettorEmpty} alt="검색된 베터 없음 이미지"/>
      emptyTxt = '검색된 베터가 없습니다.\n다시 한번 입력해주세요.'
      className.push('adv-empty-bettor-list')
      break
    case EMPTY_ICON.BETTOR_FIND_NEW_MEMBER:
      emptyIco = <img src={bettorEmpty} alt="검색된 베터 없음 이미지"/>
      emptyTxt = '신규가입한 베터가 없습니다.'
      className.push('adv-empty-bettor-list')
      break
    case EMPTY_ICON.BETTOR_FIND_FIRST_BET:
      emptyIco = <img src={bettorEmpty} alt="검색된 베터 없음 이미지"/>
      emptyTxt = '첫 베팅한 베터가 없습니다.'
      className.push('adv-empty-bettor-list')
      break
    case EMPTY_ICON.BETTOR_FIND_HIT_SUCCESS:
      emptyIco = <img src={bettorEmpty} alt="검색된 베터 없음 이미지"/>
      emptyTxt = '예측에 성공한 베터가 없습니다.'
      className.push('adv-empty-bettor-list')
      break
    case EMPTY_ICON.BETTOR_FIND_TODAY_BETTOR:
      emptyIco = <img src={bettorEmpty} alt="검색된 베터 없음 이미지"/>
      emptyTxt = '오늘의 베터가 없습니다.'
      className.push('adv-empty-bettor-list')
      break
    case EMPTY_ICON.BET_HISTORY:
      emptyIco = <img src={basicEmpty} alt="베팅내역 없음 이미지"/>
      emptyTxt = '베팅내역이 없습니다.'
      className.push('adv-empty-bet-history')
      break
    case EMPTY_ICON.BET_SHARED:
      emptyIco = <img src={basicEmpty} alt="저장된 베팅내역 없음 이미지"/>
      emptyTxt = '저장내역이 없습니다.'
      className.push('adv-empty-bet-history')
      break
    case EMPTY_ICON.BET_KEEP:
      emptyIco = <img src={basicEmpty} alt="보관된 베팅내역 없음 이미지"/>
      emptyTxt = '보관내역이 없습니다.'
      className.push('adv-empty-bet-history')
      break
    case EMPTY_ICON.MATCH:
      emptyIco = <img src={matchEmpty} alt="경기 없음 이미지"/>
      emptyTxt = '베팅할 수 있는 경기가 없습니다.'
      className.push('adv-empty-match')
      break
    case EMPTY_ICON.MATCH_DETAIL:
      emptyIco = <img src={basicEmpty} alt="상세경기 없음 이미지"/>
      emptyTxt = '베팅할 수 있는 상세 경기가 없습니다.'
      className.push('adv-empty-match-detail contents-tab')
      break
    case EMPTY_ICON.MATCH_DETAIL_PC:
    case EMPTY_ICON.LIVE_DETAIL_PC:
      emptyIco = <img src={basicEmpty} alt="선택된 상세경기 없음 이미지"/>
      emptyTxt = '선택된 상세 베팅이 없습니다.'
      className.push('adv-empty-match-detail contents-tab')
      break
    case EMPTY_ICON.MATCH_RESULT:
      emptyIco = <img src={matchEmpty} alt="경기 없음 이미지"/>
      emptyTxt = '확인할 수 있는 경기가 없습니다.'
      className.push('adv-empty-match')
      break
    case EMPTY_ICON.MATCH_RESULT_MYBET:
      emptyIco = <img src={matchEmpty} alt="경기 없음 이미지"/>
      emptyTxt = '베팅한 경기 중 확인할 수 있는 경기가 없습니다.'
      className.push('adv-empty-match')
      break
    case EMPTY_ICON.MESSAGE_SENT:
      emptyIco = <img src={messageEmpty} alt="보낸 메세지 없음 이미지"/>
      emptyTxt = '보낸 메시지가 없습니다.'
      break
    case EMPTY_ICON.MESSAGE_RECV:
      emptyIco = <img src={messageEmpty} alt="받은 메세지 없음 이미지"/>
      emptyTxt = '받은 메시지가 없습니다.'
      break
    case EMPTY_ICON.CLUB_MESSAGE_SENT:
      emptyIco = <img src={clubNoteEmpty} alt="보낸 쪽지 없음 이미지"/>
      emptyTxt = '보낸 쪽지가 없습니다.'
      break
    case EMPTY_ICON.CLUB_MESSAGE_RECV:
      emptyIco = <img src={clubNoteEmpty} alt="받은 쪽지 없음 이미지"/>
      emptyTxt = '받은 쪽지가 없습니다.'
      break
    case EMPTY_ICON.LIVE:
      emptyIco = <img src={matchEmpty} alt="진행중인 라이브 경기 없음 이미지"/>
      emptyTxt = '현재 진행중인 라이브 경기가 없습니다.'
      className.push('adv-empty-match-live')
      break
    case EMPTY_ICON.LIVE_PLAN:
      emptyIco = <img src={matchEmpty} alt="예정된 라이브 경기 없음 이미지"/>
      emptyTxt = '진행 예정된 라이브 경기가 없습니다.'
      break
    case EMPTY_ICON.LIVE_DETAIL:
      emptyIco = <img src={matchDetailEmpty} alt="상세 경기 없음 이미지"/>
      emptyTxt = '베팅할 수 있는 라이브 상세 경기가 없습니다.'
      break
    case EMPTY_ICON.LIVE_MYBET:
      emptyIco = <img src={matchEmpty} alt="진행중인 라이브 경기 없음 이미지"/>
      emptyTxt = '베팅한 경기 중 라이브 경기가 없습니다.'
      className.push('adv-empty-match-live')
      break
    case EMPTY_ICON.PICK:
      emptyIco = <img src={pickEmpty} alt="판매중인 픽 없음 이미지"/>
      emptyTxt = '판매중인 픽이 없습니다.\n픽을 등록해주세요.'
      break
    case EMPTY_ICON.PICK_SALE:
      emptyIco = <img src={pickEmpty} alt="판매한 픽 없음 이미지"/>
      emptyTxt = '내가 판매한 픽이 없습니다.\n픽을 등록해주세요.'
      break
    case EMPTY_ICON.PICK_PURCHASE:
      emptyIco = <img src={pickEmpty} alt="구매한 픽 없음 이미지"/>
      emptyTxt = '구매한 픽이 없습니다.\n픽거래소를 통해 픽을 구매하세요.'
      break
    case EMPTY_ICON.VISUALIZATION:
      emptyIco = <img src={pickEmpty} alt="매치 정보 없음 이미지" className="visualization-empty"/>
      emptyTxt = '매치 정보를 지원하지 않는 경기입니다.'
      break
    case EMPTY_ICON.MATCH_FILTER:
      emptyIco = <img src={leagueEmpty} alt="진행중인 리그 없음 이미지"/>
      emptyTxt = '현재 진행중인 리그가 없습니다.'
      className.push('adv-empty-match-filter')
      break
    case EMPTY_ICON.MONEY_HISTORY:
      emptyIco = <img src={pickEmpty} alt="뱅크 내역 없음 이미지"/>
      emptyTxt = '뱅크 내역이 없습니다.'
      break
    case EMPTY_ICON.ITEM_HISTORY:
      emptyIco = <img src={pickEmpty} alt="내역 없음 이미지"/>
      emptyTxt = '아이템 내역이 없습니다.'
      break
    case EMPTY_ICON.MATCH_RESULT_PC:
      emptyIco = <img src={matchEmpty} alt="경기 없음 이미지"/>
      emptyTxt = '클럽 이동 시 상세 경기를 확인할 수 있습니다.'
      className.push('adv-empty-match-detail')
      break
    case EMPTY_ICON.ONE_FOLD_CLUB:
      emptyIco = <img src={leagueEmpty} alt="`1폴드 가능 클럽 없음 이미지"/>
      emptyTxt = '현재 1폴드 가능 클럽이 없습니다.'
      className.push('adv-empty-one-fold-club')
      break
    case EMPTY_ICON.CHANGE_MATCH:
      emptyIco = <img src={matchEmpty} alt="`1폴드 가능 클럽 없음 이미지"/>
      emptyTxt = '24시간 안에 다른 경기가 없습니다.'
      className.push('adv-empty-change-match')
      break
    case EMPTY_ICON.CHANGE_MATCH_LIVE:
      emptyIco = <img src={matchEmpty} alt="`1폴드 가능 클럽 없음 이미지"/>
      emptyTxt = '현재 진행중인 라이브 경기가 없습니다.'
      className.push('adv-empty-change-match')
      break
    case EMPTY_ICON.FAVORITE_MATCH:
      emptyIco = <img src={matchEmpty} alt="`찜한 경기 없음 이미지"/>
      emptyTxt = '찜한 경기가 없습니다.'
      break
    case EMPTY_ICON.LIVE_DISABLED:
      emptyIco = <img src={matchEmpty} alt="진행중인 라이브 경기 없음 이미지"/>
      emptyTxt = '라이브 경기가 비활성화된 클럽입니다.'
      className.push('adv-empty-match-live')
      break
    case EMPTY_ICON.CHAT_PICK:
      emptyIco = <img src={chatPickEmpty} alt="새로운 분석글이 없습니다."/>
      emptyTxt = '새로운 분석글이 없습니다.'
      // className.push('adv-empty-match-live')
      break
    case EMPTY_ICON.DIVIDEND_CARD:
      emptyIco = <img src={grayEmpty} alt="보유한 신의 가호가 없습니다."/>
      emptyTxt = '보유한 신의 가호가 없습니다.'
      className.push('adv-empty-dividend-card')
      break
    case EMPTY_ICON.USER_PICK_LIST:
      emptyIco = <img src={basicEmpty} alt="작성된 분석글이 없습니다."/>
      emptyTxt = '작성된 분석글이 없습니다.'
      className.push('adv-empty-match')
      break
    case EMPTY_ICON.USER_PICK_LIST_ITEM:
      emptyIco = <img src={basicEmpty} alt="선택한 마켓에 작성된 분석글이 없습니다."/>
      emptyTxt = '선택한 마켓에 작성된 분석글이 없습니다.'
      break
    case EMPTY_ICON.MATCHUP_DETAIL_PICK_LIST:
      emptyIco = <img src={basicEmpty} alt="작성된 분석글이 없습니다."/>
      emptyTxt = '작성된 분석글이 없습니다.'
      break
    case EMPTY_ICON.USER_PICK_PROFILE:
      emptyIco = <img src={basicEmpty} alt="작성한 분석글이 없습니다."/>
      emptyTxt = '작성한 분석글이 없습니다.'
      className.push('adv-empty-user-pick-profile')
      break
    case EMPTY_ICON.USER_PICK_ACTIVITY:
      emptyIco = <img src={basicEmpty} alt="작성한 분석글이 없습니다."/>
      emptyTxt = '작성한 분석글이 없습니다.'
      break
    case EMPTY_ICON.USER_PICK_COMMENT_ACTIVITY:
      emptyIco = <img src={basicEmpty} alt="작성한 나도 승부사 댓글이 없습니다."/>
      emptyTxt = '작성한 나도 승부사 댓글이 없습니다.'
      break
    case EMPTY_ICON.COMPANY_PICK_COMMENT_ACTIVITY:
      emptyIco = <img src={basicEmpty} alt="작성한 프리미엄 분석가 댓글이 없습니다."/>
      emptyTxt = '작성한 프리미엄 분석가 댓글이 없습니다.'
      break
    case EMPTY_ICON.USER_PICK_LIKE_ACTIVITY:
      emptyIco = <img src={basicEmpty} alt="좋아요한 글이 없습니다."/>
      emptyTxt = '좋아요한 글이 없습니다.'
      break
    case EMPTY_ICON.USER_PICK_INDIVIDUAL_MATCH:
      emptyIco = <img src={basicEmpty} alt="해당 경기의 베팅내역이 없습니다."/>
      emptyTxt = '해당 경기의 베팅내역이 없습니다.'
      break
    case EMPTY_ICON.TODAY_USER_PICK_LIST:
      emptyIco = <img src={basicEmpty} alt="오늘의 승부사로 선정된 분석글이 없습니다."/>
      emptyTxt = '오늘의 승부사로 선정된 분석글이 없습니다.'
      break
    case EMPTY_ICON.USER_HIT_PICK_LIST:
      emptyIco = <img src={basicEmpty} alt="적중한 분석글이 없습니다."/>
      emptyTxt = '적중한 분석글이 없습니다.'
      break
    case EMPTY_ICON.PICK_COMMENT_LIST:
      emptyIco = <img src={basicEmpty} alt="아직 댓글이 없습니다. 가장 먼저 댓글을 남겨보세요."/>
      emptyTxt = '아직 댓글이 없습니다.\n가장 먼저 댓글을 남겨보세요.'
      break
    case EMPTY_ICON.ACTIVITY_HISTORY_LIST:
      emptyIco = <img src={basicEmpty} alt="획득한 활동점수가 없습니다."/>
      emptyTxt = '획득한 활동점수가 없습니다.'
      break
    case EMPTY_ICON.USER_BLOCK_LIST:
      emptyIco = <img src={basicEmpty} alt="차단내역이 없습니다."/>
      emptyTxt = '차단한 유저가 없습니다.'
      break
    case EMPTY_ICON.CHEER_FOR_TEAM_MATCH_LIST:
      emptyIco = <img src={grayEmpty} alt="응원할 수 있는 경기가 없습니다."/>
      emptyTxt = '응원할 수 있는 경기가 없습니다.'
      break
    case EMPTY_ICON.SHARE_BETTING_HISTORY_LIST:
      emptyIco = <img src={basicEmpty} alt="공유한 베팅내역이 없습니다."/>
      emptyTxt = '공유한 베팅이 없습니다.'
      break
    case EMPTY_ICON.SPORT_TALK_LIST:
      emptyIco = <img src={basicEmpty} alt="작성된 스포츠톡이 없습니다."/>
      emptyTxt = '작성된 스포츠톡이 없습니다.'
      break
    case EMPTY_ICON.MATCHUP_DETAIL_INDIVIDUAL_MATCH:
      emptyIco = <img src={basicEmpty} alt="해당 경기의 베팅내역이 없습니다."/>
      emptyTxt = '해당 경기의 베팅내역이 없습니다.'
      break
    case EMPTY_ICON.MATCHUP_DETAIL_MATCH:
      emptyIco = <img src={basicEmpty} alt="선택한 경기가 없습니다."/>
      emptyTxt = '선택한 경기가 없습니다.'
      break
    case EMPTY_ICON.POPULAR_SEARCH_LIST:
      emptyIco = <img src={basicEmpty} alt="검색어와 관련된 뉴스가 없습니다."/>
      emptyTxt = '검색어와 관련된 뉴스가 없습니다.'
      break
    case EMPTY_ICON.TIMELINE_LIST:
      emptyIco = <img src={grayEmpty} alt="타임라인 정보가 없습니다."/>
      emptyTxt = '타임라인 정보가 없습니다.'
      break
  }

  return (
    <EmptyWrap className={className.join(' ')}>
      <div className="empty-wrap">
        <div className="empty-wrap--ico">{emptyIco}</div>
        <div className="empty-wrap--txt">{emptyTxt}</div>
        {/*{emptyElem}*/}
      </div>
    </EmptyWrap>
  )
})
